<template>
  <div class="MlTree-container" v-if="render">
    <div class="item">
      <div class="top">
        <div class="top-left">
          <el-checkbox
            v-if="showCheckAll"
            v-model="isCheckAll"
            :disabled="isDisableAll"
            >未选</el-checkbox
          >
          <span v-else>未选</span>
        </div>
        <div class="top-right">
          {{ leftYxCheckedIds.length }}/{{ leftYxNodeIds.length }}
        </div>
      </div>
      <div class="search">
        <img src="@/assets/images/search.png" />
        <el-input placeholder="请输入" v-model="keyword1"> </el-input>
      </div>
      <div class="tree">
        <el-tree
          ref="leftTree"
          :data="list"
          show-checkbox
          node-key="id"
          :props="treeProps"
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          :filter-node-method="filterLeftNode"
          @check="checkFnc"
        >
        </el-tree>
      </div>
    </div>

    <div class="item">
      <div class="top">
        <div class="top-left">已选</div>
        <div class="top-right">
          {{ leftYxCheckedIds.length }}
        </div>
      </div>
      <div class="search">
        <img src="@/assets/images/search.png" />
        <el-input placeholder="请输入" v-model="keyword2"> </el-input>
      </div>
      <div class="tree">
        <el-tree
          ref="rightTree"
          :data="checkTree"
          node-key="id"
          :props="treeProps"
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          :filter-node-method="filterLeftNode"
        >
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <div class="label">{{ node.label }}</div>
            <i
              class="el-icon-delete"
              :style="{ cursor: isDisableAll ? 'not-allowed' : 'pointer' }"
              @click="remove(node, data)"
            ></i>
          </div>
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MlTree',
  props: {
    list: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
    disabledKeys: {
      type: Array,
    },
    keyRule: {
      // 键值对规则
      type: Object,
      default: () => {
        return {
          label: 'name',
          isLeaf: 'leaf',
        };
      },
    },
    defaultKeys: {
      type: Object,
      default: () => {
        return {
          checkList: [],
          openList: [],
        };
      },
    },
    countNodeRule: {
      type: Object,
      // 根据此规则计算node数量
      default: () => {
        return {
          key: '',
          value: '',
        };
      },
    },
    showCheckAll: {
      type: Boolean,
      default: false,
    },
    isDisableAll: {
      // 是否全部禁用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      render: false,
      defaultExpandedKeys: [],
      checkedNodes: [], // 左侧选中的节点，但不是有效节点
      defaultCheckedKeys: [],
      checkTree: [], // 右侧选中数据
      disabledList: [],
      treeProps: { label: 'name', isLeaf: 'leaf' },
      keyword1: '',
      keyword2: '',
      leftYxNodeIds: [], // 有效节点
      leftYxCheckedIds: [], // 有效选中节点
      isCheckAll: false, // 是否全选
    };
  },
  watch: {
    defaultKeys(val) {
      val && this.getDefaultCheckExpandedKeys(val);
    },
    keyword1(val) {
      this.$refs.leftTree.filter(val);
    },
    keyword2(val) {
      this.$refs.rightTree.filter(val);
    },
    list: {
      handler() {
        this.leftYxNodeIds = this.getYxNode();
      },
      immediate: true,
      deep: true,
    },
    checkedNodes() {
      let list = [];
      const { key, value } = this.countNodeRule || {};
      if (!key || !value) {
        return;
      }
      this.checkedNodes.forEach((v) => {
        if (v[key] === value) {
          list.push(v.id);
        }
      });
      this.leftYxCheckedIds = list;
    },
    isCheckAll() {
      this.checkAllFnc();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.disabledList = this.disabledKeys || [];
      this.treeProps = {
        label: 'name',
        isLeaf: 'leaf',
        disabled: (data, node) => {
          const index = this.disabledList.findIndex((id) => id === data.id);
          return index > -1;
        },
      };
      if (this.isDisableAll) {
        this.treeProps = {
          label: 'name',
          isLeaf: 'leaf',
          disabled: () => {
            return true;
          },
        };
      }
      this.render = true;
    },
    /**
     * 根据规则获取有效节点
     */
    getYxNode(list) {
      let nodeIds = [];
      const { key, value } = this.countNodeRule || {};
      if (!key || !value) {
        return;
      }
      if (!list) list = this.list;
      list.forEach((v) => {
        if (v[key] === value) {
          nodeIds.push(v.id);
        }
        if (v.children.length > 0) {
          nodeIds = nodeIds.concat(this.getYxNode(v.children));
        }
      });
      return nodeIds;
    },
    /**
     * 左侧选中触发
     */
    checkFnc(item, obj) {
      // 选中数据处理后返回
      const info = this.getCheckInfo(obj);
      // 获取选中key与展开key
      this.getDefaultCheckExpandedKeys(info);
    },

    /**
     * 全选
     */
    checkAllFnc() {
      this.$refs.leftTree.setCheckedNodes(this.isCheckAll ? this.list : []);
      if (this.isCheckAll) {
        const openList = [];
        const checkList = [];
        const checkedNodes = this.$refs.leftTree.getCheckedNodes();
        checkedNodes.forEach((node) => {
          const { id, name, leaf, type } = node;
          checkList.push({ id, name, leaf, type });
          if (!leaf) {
            openList.push(id);
          }
        });
        this.checkedNodes = checkList;
        const info = {
          checkList,
          openList,
        };
        // 获取右侧选中数据树结构
        this.checkTree = this.getCheckTree({ checkList, openList });
        this.$emit('checkInfo', JSON.parse(JSON.stringify(info)));
      } else {
        const info = {
          checkList: [],
          openList: [],
        };
        this.checkedNodes = [];
        this.checkTree = [];
        this.$emit('checkInfo', info);
      }
    },

    /**
     * 传给接口的数据格式
     */
    getCheckInfo(obj) {
      const openList = JSON.parse(JSON.stringify(obj.halfCheckedKeys));
      const checkList = [];
      obj.checkedNodes.forEach((node) => {
        const { id, name, leaf, type } = node;
        checkList.push({ id, name, leaf, type });
        if (!leaf) {
          openList.push(id);
        }
      });
      const info = {
        checkList,
        openList,
      };

      this.checkedNodes = checkList;

      this.$emit('checkInfo', JSON.parse(JSON.stringify(info)));

      return info;
    },

    /**
     * 获取默认选中key与默认展开key
     */
    getDefaultCheckExpandedKeys(info) {
      const { checkList, openList } = info || {};
      this.defaultExpandedKeys = openList || [];
      const list = [];
      (checkList || []).forEach((v) => {
        list.push(v.id);
      });
      this.defaultCheckedKeys = list;
      this.checkedNodes = checkList;
      this.isCheckAll = checkList.length === this.leftYxNodeIds.length;
      this.checkTree = this.getCheckTree({ checkList, openList });
    },
    /**
     * 选中的部分转换文字展示
     */
    getCheckText(checkedNodes) {
      let delList = [];
      const list = JSON.parse(JSON.stringify(checkedNodes));
      list.forEach((node) => {
        if (!node.leaf) {
          delList = delList.concat(this.getAllChildren(node.children));
        }
      });
      // 去重
      const delMap = {};
      delList.forEach((id) => {
        delMap[id] = true;
      });

      let nameList = [];

      list.forEach((node) => {
        if (!delMap[node.id]) {
          const groups = this.findPathByLeafId(node.id, this.list);
          nameList.push(groups.join('/'));
        }
      });
    },
    /**
     * 递归获取所有子节点
     */
    getAllChildren(children) {
      let childs = [];
      children.forEach((child) => {
        childs.push(child.id);
        if (child.children.length > 0) {
          childs = childs.concat(this.getAllChildren(child.children));
        }
      });

      return childs;
    },
    /**
     * 递归获取节点路径
     */
    findPathByLeafId(leafId, nodes, path) {
      if (path === undefined) {
        path = [];
      }
      for (var i = 0; i < nodes.length; i++) {
        var tmpPath = path.concat();
        tmpPath.push(nodes[i].name);
        if (leafId == nodes[i].id) {
          return tmpPath;
        }
        if (nodes[i].children) {
          var findResult = this.findPathByLeafId(
            leafId,
            nodes[i].children,
            tmpPath,
          );
          if (findResult) {
            return findResult;
          }
        }
      }
    },
    /**
     * 获取选中的树形结构
     */
    getCheckTree(info, trees) {
      let list = [];
      if (!trees) trees = JSON.parse(JSON.stringify(this.list));
      const { checkList, openList } = info;
      trees.forEach((v, index) => {
        const index1 = checkList.findIndex((v1) => v1.id === v.id);
        const index2 = openList.findIndex((v2) => v2 === v.id);
        if (index1 !== -1 || index2 !== -1) {
          if (v.children.length > 0) {
            v.children = this.getCheckTree(info, v.children);
          }
          list.push(v);
        }
      });
      return list;
    },
    /**
     * 右侧点击删除
     */
    remove(node, data) {
      if (this.isDisableAll) return;

      // 左侧取消选中
      this.$refs.leftTree.setChecked(data.id, false, true);
      // 在禁用中也去掉
      this.disabledList = this.disabledList.filter((id) => id !== data.id);

      const allChilds = this.getAllChildren(data.children);
      allChilds.forEach((id) => {
        // 在禁用中也去掉
        this.disabledList = this.disabledList.filter((v) => v !== id);
        // 左侧取消选中
        this.$refs.leftTree.setChecked(id, false, true);
      });
      const checkedNodes = this.$refs.leftTree.getCheckedNodes(false, true);
      const halfCheckedKeys = this.$refs.leftTree.getHalfCheckedKeys();
      const info = this.getCheckInfo({ checkedNodes, halfCheckedKeys });
      this.checkTree = this.getCheckTree(info);
    },
    filterLeftNode(value, data) {
      if (!value) return true;
      return data[this.keyRule.label]
        ? data[this.keyRule.label].indexOf(value) !== -1
        : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.MlTree-container {
  display: flex;
  .item {
    flex-shrink: 0;
    width: 320px;
    height: 420px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    &:first-child {
      margin-right: 20px;
    }
    .top {
      width: 100%;
      height: 40px;
      background: #f5f7fa;
      border-bottom: 1px solid #e4e7ed;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;
      .top-left {
        font-size: 14px;
        font-weight: normal;
        color: #303133;
      }
      .top-right {
        font-size: 12px;
        font-weight: normal;
        color: #909399;
      }
    }
    .search {
      margin: 16px;
      border-radius: 16px;
      overflow: hidden;
      border: 1px solid #ccd0d8;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 12px;
        height: 12px;
        margin-left: 10px;
      }
      ::v-deep .el-input__inner {
        border: none;
        padding-left: 8px;
      }
    }
    .tree {
      height: 310px;
      overflow: auto;
      ::v-deep .el-tree__empty-block {
        height: 290px;
      }

      ::v-deep .el-tree-node__label {
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    // ::v-deep .el-tree-node__children {
    //   .el-tree-node__content {
    //     padding-right: 3px;
    //   }
    // }

    .custom-tree-node {
      font-size: 14px;
      font-weight: normal;
      color: #606266;
      // width: 85%;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-right: 15px;
      .label {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 5px;
      }
    }
  }
}
</style>
